import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";

import { getShowMobileSummary } from "../../store/sagas/selectors";
import Constants from "../../constants";
import { SET_SHOW_MOBILE_SUMMARY } from "../../store/actions/menuActions";
import { useText } from "../../utilities/textUtil";

const SummaryButton = styled.div`
    position: absolute;
    top: calc(${Constants.mobileImageHeightVw}vw + 71px);
    right: 18px;
    height: 40px;
    min-width: min(170px, 45%);
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const MobileSummaryButton = () => {
    const dispatch = useDispatch();
    const showMobileSummary = useSelector(getShowMobileSummary);
    const t = useText();
    const textId = showMobileSummary ? "hideSummary" : "showSummary";
    return (
        <SummaryButton
            onClick={() => dispatch({ type: SET_SHOW_MOBILE_SUMMARY, showMobileSummary: !showMobileSummary })}
        >
            {t(textId)}
        </SummaryButton>
    );
};
